import { z } from "zod";
import shortid from "shortid";
import { normalizeColor, isCssColor } from "@/utils/normalizeColor";
// import { TopolApiBlocksSchemas } from "./APIBlocks/APIBlocks";

/**
 * A pure colour attribute. `##hex` is repaired on load; anything that is
 * still not a colour afterwards fails the schema so the field's `.catch()`
 * puts the default (or `undefined`) in place — the value never reaches the
 * renderer. Every use MUST end with `.catch(...)`: the template-level fixer
 * only understands zod's invalid_type / invalid_value issues.
 */
export const TopolColorSchema = z
  .string()
  .transform(normalizeColor)
  .pipe(z.string().refine(isCssColor, "not a CSS colour"));

/**
 * Attribute that merely CONTAINS colours (border shorthand, gradient).
 * Only `##hex` is repaired; the rest is not validated here.
 */
export const TopolColorBearingSchema = z.string().transform(normalizeColor);

export const TopolBlockSchema = z.object({
  tagName: z.string(),
  uid: z.string().catch(() => shortid.generate()),
  locked: z.coerce.boolean().optional().catch(undefined),
  customKey: z.string().nullish().catch(undefined),
  aiGenerateContent: z.string().nullish().catch(undefined),
});

export const TopolBlockCssClassSchema = z
  .enum(["hide_on_mobile", "hide_on_desktop", ""])
  .nullable();
export const TopolBlockAlignSchema = z.enum(["left", "center", "right"]);
export const TopolVertcalAlignSchema = z.enum(["top", "middle", "bottom"]);
